module.exports = "/public/assets/2006380_YyczUn.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/img/2006380_YyczUn.png
// module id = 175
// module chunks = 0